var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFilterIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 43,
    viewBox: "0 0 39 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 4.41997V5.49997C1 6.16997 1.24 6.81997 1.67 7.32997L15.33 23.48C15.76 23.99 16 24.64 16 25.31V39.08C16 41.39 18.61 42.73 20.48 41.39L21.81 40.44C22.55 39.91 23 39.05 23 38.13V25.31C23 24.64 23.24 23.99 23.67 23.48L37.33 7.32997C37.76 6.81997 38 6.16997 38 5.49997V4.41997C38 2.84997 36.73 1.58997 35.17 1.58997H3.83C2.26 1.58997 1 2.85997 1 4.41997Z",
    stroke: "#2E63EE",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterIcon);
export default __webpack_public_path__ + "static/media/filter-icon.08b6486fa55df9ed19f81c89d1347709.svg";
export { ForwardRef as ReactComponent };